<template>
  <div>
    <div style="width: 1300px; margin: 20px auto;">
      <!-- Search and Filter Card -->
      <el-card shadow="always" style="border-radius: 12px; margin-bottom: 20px; border: none;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center; gap: 15px;">
          <el-input
            v-model="userInput"
            @keyup.enter.native="triggerFilter"
            placeholder="Search publications..."
            style="width: 400px"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="triggerFilter"
            ></el-button>
          </el-input>
          
          <!-- Filters & Sort controls -->
          <div style="display: flex; align-items: center; gap: 10px;">
            <el-select v-model="filterType" @change="triggerFilter" placeholder="Filter Type" style="width: 130px;" size="small" clearable>
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            
            <el-select v-model="filterJournal" @change="triggerFilter" placeholder="Filter Journal" style="width: 150px;" size="small" clearable>
              <el-option v-for="item in journalOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>

            <el-button 
              size="small" 
              style="margin-left: 10px;" 
              @click="toggleSortMethod"
              :icon="sortMethod === 'DESC' ? 'el-icon-sort-down' : 'el-icon-sort-up'"
            >
              Sort Year: {{ sortMethod === 'DESC' ? 'Desc' : 'Asc' }}
            </el-button>
          </div>
        </div>

        <div style="display: flex; align-items: center;">
          <span style="margin-right: 10px; color: #606266; font-size: 14px;">Show</span>
          <el-dropdown @command="changeValue">
            <el-button type="info" size="small">
              <span>{{ queryInfo.pagesize }}</span><i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in option" :key="item.value" :command="item.label">
                <span>{{ item.label }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span style="margin-left: 10px; color: #606266; font-size: 14px;">entries</span>
        </div>
        </div>
      </el-card>
      
      <!-- Publication List Container -->
      <div v-loading="isLoading" style="min-height: 500px;">
        <div v-if="filteredAndSortedList.length === 0 && !isLoading" style="text-align: center; color: #909399; padding: 50px 0;">
          No publications found.
        </div>
        <div v-else style="display: flex; flex-direction: column; gap: 15px;">
          <el-card 
            v-for="(item, index) in displayList" 
            :key="index"
            class="publication-card"
            shadow="hover"
          >
            <div class="card-header">
              <h3 class="pub-title" v-html="item.title"></h3>
              <div class="pub-meta">
                <el-tag size="small" type="success" effect="plain" v-if="item.type">{{ item.type }}</el-tag>
                <span class="pub-year"><i class="el-icon-date"></i> {{ item.year }}</span>
              </div>
            </div>
            
            <div class="card-body">
              <p class="pub-authors"><strong>Authors:</strong> <span v-html="item.authors"></span></p>
              <p class="pub-journal"><strong>Journal:</strong> <span>{{ item.source }}</span></p>
            </div>
            
            <div class="card-footer">
              <div @click="viewDetail(item)" class="doi-link">
                <strong>DOI:</strong> <span>{{ item.doi }}</span>
                <svg
                  class="doi-icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                >
                  <path
                    d="M790.536784 923.653571 77.292364 923.653571 77.292364 228.828662 625.784486 228.828662 625.784486 264.644379 113.108081 264.644379 113.108081 887.837854 753.697761 887.837854 753.697761 410.977165 790.536784 410.977165Z"
                    fill="#14AEED"
                  ></path>
                  <path
                    d="M904.925691 115.801844l25.885344 25.885344-400.116482 400.116482-25.885344-25.885344 400.116482-400.116482Z"
                    fill="#14AEED"
                  ></path>
                  <path
                    d="M932.909375 340.16233 896.369158 338.016457 908.096247 138.5311 708.61089 150.258189 706.465017 113.717971 947.06784 99.559507Z"
                    fill="#14AEED"
                  ></path>
                </svg>
              </div>
            </div>
          </el-card>
        </div>
      </div>
        <div style="display: flex; width: 1300px; margin: auto">
          <div
            class="block"
            style="margin: 20px auto; width: 600px; display: inline-block"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="queryInfo.pagesize"
              layout="prev, pager, next, jumper"
              :total="filteredAndSortedList.length"
              :current-page.sync="queryInfo.pagenum"
            >
            </el-pagination>
          </div>
          <span style="margin: 20px auto; float: right"
            >Showing
            {{
              filteredAndSortedList.length == 0 ? 0 : (queryInfo.pagenum - 1) * queryInfo.pagesize + 1
            }}
            to
            {{
              queryInfo.pagenum * queryInfo.pagesize > filteredAndSortedList.length
                ? filteredAndSortedList.length
                : queryInfo.pagenum * queryInfo.pagesize
            }}
            of {{ filteredAndSortedList.length }} entries</span
          >
        </div>
    </div>

    </div>
</template>
  
  <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Publication",
  components: {  },
  data() {
    return {
      queryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      isLoading: false,
      allPublications: [],
      sort: "year",
      sortMethod: "DESC",
      filterType: "",
      filterJournal: "",
      typeOptions: [],
      journalOptions: [],
      userInput: "",
      option: [
        { label: 10, value: 0 },
        { label: 25, value: 1 },
        { label: 50, value: 2 },
        { label: 100, value: 3 },
      ],
    };
  },
  computed: {
    filteredAndSortedList() {
      let list = this.allPublications;
      
      // Filter by userInput (search title or authors)
      if (this.userInput) {
        const query = this.userInput.toLowerCase();
        list = list.filter(item => 
          (item.title && item.title.toLowerCase().includes(query)) ||
          (item.authors && item.authors.toLowerCase().includes(query))
        );
      }
      
      // Filter by Type
      if (this.filterType) {
        list = list.filter(item => item.type === this.filterType);
      }
      
      // Filter by Journal
      if (this.filterJournal) {
        list = list.filter(item => item.source === this.filterJournal);
      }
      
      // Sort by Year
      list = list.slice().sort((a, b) => {
        const yearA = parseInt(a.year) || 0;
        const yearB = parseInt(b.year) || 0;
        if (this.sortMethod === 'DESC') {
          return yearB - yearA;
        } else {
          return yearA - yearB;
        }
      });
      
      return list;
    },
    displayList() {
      const start = (this.queryInfo.pagenum - 1) * this.queryInfo.pagesize;
      const end = start + this.queryInfo.pagesize;
      return this.filteredAndSortedList.slice(start, end);
    }
  },
  created() {
    this.getFilterOptions();
    this.getPublicationList();
  },
  methods: {
    async getFilterOptions() {
      // Data is pre-aggregated to avoid a massive 1.5MB request that blocks the UI and causes delays
      const types = ["J", "C", "S"];
      const journals = [
        "MITOCHONDRIAL DNA PART B-RESOURCES", "SCIENTIFIC REPORTS", "MITOCHONDRIAL DNA PART A",
        "BMC GENOMICS", "FRONTIERS IN PLANT SCIENCE", "PLOS ONE", "INTERNATIONAL JOURNAL OF MOLECULAR SCIENCES",
        "GENES", "BMC PLANT BIOLOGY", "GENOME BIOLOGY AND EVOLUTION", "FRONTIERS IN MICROBIOLOGY",
        "PLANTS-BASEL", "INSECTS", "GENE", "PEERJ", "INTERNATIONAL JOURNAL OF BIOLOGICAL MACROMOLECULES",
        "G3-GENES GENOMES GENETICS", "FRONTIERS IN GENETICS", "MOLECULAR PHYLOGENETICS AND EVOLUTION",
        "MOLECULAR BIOLOGY AND EVOLUTION", "PLANT JOURNAL", "Microbiology resource announcements",
        "ECOLOGY AND EVOLUTION", "CONSERVATION GENETICS RESOURCES", "GENOMICS", "PLANT PHYSIOLOGY",
        "NUCLEIC ACIDS RESEARCH", "NEW PHYTOLOGIST", "MITOCHONDRION", "PLANTA", "NATURE COMMUNICATIONS",
        "JOURNAL OF FUNGI", "JOURNAL OF INSECT SCIENCE", "BMC BIOLOGY"
      ];
      this.typeOptions = types.map(t => ({ 
        label: t === 'J' ? 'Journal Article' : (t === 'C' ? 'Conference Proceeding' : (t === 'S' ? 'Symposium' : t)), 
        value: t 
      }));
      this.journalOptions = journals.map(j => ({ label: j, value: j }));
    },
    async getPublicationList() {
      if (
        sessionStorage.getItem("userInputPublicationHome") != null &&
        sessionStorage.getItem("userInputPublicationHome") != ""
      ) {
        this.userInput = sessionStorage.getItem("userInputPublicationHome");
        sessionStorage.setItem("userInputPublicationHome", "");
      }
      
      this.queryInfo.pagenum = 1;

      if (this.allPublications.length === 0) {
        const cachedData = sessionStorage.getItem("allPublications");
        if (cachedData) {
          try {
            this.allPublications = JSON.parse(cachedData);
            return;
          } catch (e) {
            console.error("Failed to parse cached publications");
          }
        }
        
        this.isLoading = true;
        try {
          const { data: res } = await this.$axios.get(
            "/api/api.publication/list",
            {
              params: {
                page: 1,
                pageSize: 10000,
              },
            }
          );
          if (res && res.data && res.data.rows) {
            this.allPublications = res.data.rows;
            try {
              sessionStorage.setItem("allPublications", JSON.stringify(this.allPublications));
            } catch(e) {
              console.warn("Could not cache to sessionStorage (possibly too large)", e);
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoading = false;
        }
      }
    },
    triggerFilter() {
      this.queryInfo.pagenum = 1;
    },
    toggleSortMethod() {
      this.sortMethod = this.sortMethod === 'DESC' ? 'ASC' : 'DESC';
      this.triggerFilter();
    },
    handleCurrentChange(val) {
      this.queryInfo.pagenum = val;
    },
    changeValue(e) {
      this.queryInfo.pagesize = e;
      this.triggerFilter();
    },
    viewDetail(row) {
      //跳转doi界面

      const targetUrl = "http://doi.org/" + row.doi;
      // 在新窗口中打开目标URL
      window.open(targetUrl, "_blank");
    },
    inputContent(e) {
      this.userInput = e;
      this.triggerFilter();
    },
  },
};
</script>
  
  <style scoped>
.publication-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.publication-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.pub-title {
  margin: 0;
  font-size: 18px;
  color: #303133;
  line-height: 1.4;
  flex: 1;
  padding-right: 20px;
}
.pub-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.pub-year {
  color: #909399;
  font-size: 14px;
}
.card-body p {
  margin: 8px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}
.card-footer {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}
.doi-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #409EFF;
  cursor: pointer;
}
.doi-link:hover {
  text-decoration: underline;
}
.doi-icon {
  vertical-align: middle;
}
</style>